
import { Checkbox, Tooltip } from 'antd';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Icon } from 'semantic-ui-react';
import { COMPANY_LOOKUP_HOST } from '../../../../constants';
import { translations } from '../../../../utils/LocalizedStrings';
import { isoCountryCodes } from '../../../editor/countries/countries';
import { useFormDataContext } from '../../contexts/form-data.ctx';
import ProcessDocuments from './ProcessDocuments';
import { RegistrationCertificateDataMutator, RegistrationCertificateDataRenderer } from './RegistrationCertificateDataArtifact';
import { RegistrationCertificatePersonMutator, RegistrationCertificatePersonRenderer, validateRegistrationCertificatePerson } from './RegistrationCertificatePerson';

const _ = require('lodash');

function RegistrationCertificateMutator({ documentId, name, disabled, binding, label = 'Select', ...rest }) {

    const [, updateState] = React.useState({})
    const forceUpdate = React.useCallback(() => updateState({}), [])

    const [loaded, setLoaded] = React.useState(false)

    const prepareEmptyRegistrationCertificateData = () => {
        return {
            data: {
                vin: '',
                evidencneCislo: '',
                cisloTechnickehoPreukazu: '',
                rokVyrobyVozidla: '',
                druh: '',
                znacka: '',
                typ: '',
                farba: ''
            }
        }
    }

    const [fieldValues, setFieldValues] = useState({ value: prepareEmptyRegistrationCertificateData() })

    const values = useFormDataContext(({ data, setField }) => ({
        value: data[name] || prepareEmptyRegistrationCertificateData(),
        userPersons: data.userPersons || [],
        setField
    }));

    useEffect(() => {
        if (!loaded) {
            let tmpValues = JSON.parse(JSON.stringify(fieldValues))
            tmpValues.value.data = values.value.data
            setFieldValues(tmpValues)
            setLoaded(!loaded)
            forceUpdate()
        }
    }, [values])

    const handleChange = () => {
        values.setField({
            target: {
                name,
                value: fieldValues.value
            },
        });
    }

    const handleChangeData = (valuesData) => {
        handleChangePart(valuesData, 'data')
    }

    const handleChangePart = (valuesToChange, person) => {
        let tmpPerson = fieldValues.value[person]
        const tmpMerge = _.merge(tmpPerson, valuesToChange);
        let tmpValues = fieldValues.value
        tmpValues[person] = tmpMerge
        setFieldValues({ value: tmpValues })
    }

    const onFocus = () => {
        document.querySelectorAll('.mention[data-id="' + name + '"]').forEach((el) => {
            el.classList.add('mention--focus');
        });
    };

    const onBlur = () => {
        document.querySelectorAll('.mention[data-id="' + name + '"]').forEach((el) => {
            el.classList.remove('mention--focus');
        });
        handleChange();
    };


    const setScannedDataRegistrationCertificate = (value) => {
        console.log("REGISTRATION Certificate ARTIFACT", value);
        const tmp = _.merge(fieldValues.value, value)
        fieldValues.value = tmp
        setFieldValues(fieldValues);


        forceUpdate()
        values.setField({
            target: {
                name,
                value: tmp
            },
        });
    }



    return (
        <>
            <form className="fullGridRow registerCertificateArtifact newPersonForm">
                <div className='gridRow'>
                    <p className='inputLabelTooltip'>
                        <h4>{label}</h4>
                        {rest.tooltip && (
                            <div style={{ marginBottom: 20 }} className="icon-position">
                                <Tooltip title={rest.tooltip}>
                                    <span className="icon-info">
                                        <Icon name="info circle" />
                                    </span>
                                </Tooltip>
                            </div>
                        )}
                    </p>
                    <ProcessDocuments
                        parentId={name}
                        setScannedData={setScannedDataRegistrationCertificate}
                        processLabel={translations.artifacts.RegistrationCertificateArtifact.uploadImageForScanning}
                        processLabelTooltip={translations.artifacts.RegistrationCertificateArtifact.uploadImageForScanningTooltip}
                    />
                </div>
                <RegistrationCertificateDataMutator
                    name={name}
                    values={fieldValues.value.data}
                    handleChange={handleChangeData}
                    // setEdited={setEditedOwner}
                    disabled={false}
                    tooltip={translations.artifacts.RegistrationCertificateArtifact.tooltipDataText}
                    label={translations.artifacts.RegistrationCertificateArtifact.labelData}
                    onFocus={onFocus}
                    onBlur={onBlur}
                />
            </form>
        </>
    );
}

function RegistrationCertificateRenderer(values, id) {

    let returnValue = ""
    if (
        values &&
        values[id]
    ) {
        if (values[id].data)
            returnValue += RegistrationCertificateDataRenderer(values[id].data)

        return returnValue
    }

}

function validateRegistrationCertificate(values, key) {
    console.log("validate certificate", values[key], values, key)
    if (!values || !values[key] || !values[key].data) {
        return false
    }
    const data = values[key].data
    console.log(data)
    if (!data.vin || !data.evidencneCislo || !data.cisloTechnickehoPreukazu || !data.rokVyrobyVozidla || !data.druh || !data.znacka || !data.typ || !data.farba) {
        return false
    }
    return true
}

function validateRegistrationCertificateFields(values, key) {
    let invalidFields = []
    if (!values || !values[key] || !values[key].data) {
        invalidFields = [key + "_vin", key + "_evidencneCislo", key + "_cisloTechnickehoPreukazu", key + "_rokVyrobyVozidla", key + "_druh", key + "_znacka", key + "_typ", key + "_farba"]
    } else {
        const data = values[key].data
        if (!data.vin) {
            invalidFields.push(key + "_vin")
        }
        if (!data.evidencneCislo) {
            invalidFields.push(key + "_evidencneCislo")
        }
        if (!data.cisloTechnickehoPreukazu) {
            invalidFields.push(key + "_cisloTechnickehoPreukazu")
        }
        if (!data.rokVyrobyVozidla) {
            invalidFields.push(key + "_rokVyrobyVozidla")
        }
        if (!data.druh) {
            invalidFields.push(key + "_druh")
        }
        if (!data.znacka) {
            invalidFields.push(key + "_znacka")
        }
        if (!data.typ) {
            invalidFields.push(key + "_typ")
        }
        if (!data.farba) {
            invalidFields.push(key + "_farba")
        }

    }
    return invalidFields
}


export default {
    Mutator: RegistrationCertificateMutator,
    HTMLRenderer: RegistrationCertificateRenderer,
    Validator: validateRegistrationCertificate,
    FieldsValidator: validateRegistrationCertificateFields
};
